import { Avatar, AvatarImage } from '@savvy-kit/components/avatar';
import { Landmark } from 'lucide-react';

export function isBase64URL(imgUrl?: string) {
  if (!imgUrl) return false;
  return !imgUrl.startsWith('http') && !imgUrl.startsWith('data:');
}

export function providerImgSrc(providerLogo?: string) {
  if (isBase64URL(providerLogo)) {
    return `data:image/jpeg;base64, ${providerLogo}`;
  }
  return providerLogo;
}

export function renderProviderImg(providerLogo: string, size = 24) {
  if (!providerLogo) {
    return <Landmark style={{ width: size, height: size }} />;
  }

  return (
    <Avatar style={{ height: size, width: size }}>
      <AvatarImage src={providerImgSrc(providerLogo)} />
    </Avatar>
  );
}
